import * as signalR from "@microsoft/signalr";
import config from "./config";

export let connection = null;

export const getConnectionId = () => {
  try {
    if (connection) {
      return connection?.connection?.connectionId;
    }
  } catch {}
  return "";
};

export function startConnection() {
  connection = new signalR.HubConnectionBuilder()
    .configureLogging(signalR.LogLevel.Information)
    .withUrl(`${config.apiUrl}/hubs/messenger`, {
      accessTokenFactory: () => {
        let a = localStorage.getItem("access_token");
        return a;
      },
    })
    .withAutomaticReconnect()
    .build();

  // connection.on("ReceiveMessage", (chatId, message) => {
  //   // پیام دریافتی را به کامپوننت ارسال کنید
  //   console.log("Message received:", chatId);
  //   console.log("Message received:", message);
  // });

  connection.on("Ping", () => {
    connection.invoke("Pong");
  });

  connection.on("UpdateMessageStatus", (chatId, messageId, status) => {
    // وضعیت پیام را به‌روزرسانی کنید
    console.log("Message status updated:", { messageId, status });
  });

  connection.on("UserOnlineStatusChanged", (userId, isOnline) => {
    // setUsers((prevUsers) =>
    //   prevUsers.map((user) =>
    //     user.id === userId ? { ...user, isOnline } : user
    //   )
    // );
    console.error("Connection closed:", isOnline);
  });

  connection.onclose((error) => {
    console.error("Connection closed:", error);
  });

  connection
    .start()
    .then((s) => console.log("SignalR connected", connection))
    .catch((err) => console.error("SignalR connection error:", err));
}

export function stopConnection() {
  if (connection) {
    connection.stop();
  }
}

export function sendMessage(chatId, message) {
  console.log("Sending message:", message);

  if (connection) {
    connection
      .invoke("SendMessage", `${chatId}`, message?.Text)
      .catch((err) => console.error(err));
  }
}
